import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const PermissionsPage = lazy(() =>
  import('../../pages/admin/permissions/PermissionsPage').then((m) => ({
    default: m.PermissionsPage,
  })),
);

export const Route = createFileRoute('/admin/permissions')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <PermissionsPage />
    </Suspense>
  ),
});
